import styles from "./agentStatus.module.scss";
import { useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import moment from "moment-timezone";
import { GetItemFromStorage } from "../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";
import { CallServices } from "../../../../base/service/apiServices";
import { isJSON } from "../../../../base/utils";
import NoDataFound from "../../../nodatafound/nodatafound";
function AgentQueueTracker() {
  const commonReducer: any = useSelector((state: any) => state.queueTracker);
  let { queueTrackerData ,timer} = commonReducer;
  const [counter, setCounter] = useState<any>(0);
  const [servertimer, setServerTimer] = useState<any>(timer);

  const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const agentList: any = useSelector((state: any) => state.agentTracker.agentList)

  // const answerCall = (data: any) => { console.log("answer>>")};

  useEffect(() => {
    setCounter(0);
    const timer = setInterval(() => {
      setCounter((count: any) => count + 1);
    }, 1000);
    // return () => {
    //   clearInterval(timer);
    // };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setServerTimer((servertimer: any) => servertimer + 1);
    }, 1000);
    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  const getTime = async () => {
    try {
      const time = await CallServices.get("/time")
      setServerTimer(time?.data?.serverTime ?? 0)
    } catch (error) {
      console.log('time error', error)
    }
  }

  // useEffect(() => {
  //   getTime()
  // }, [])
  useEffect(() => {
    getTime()
  }, [queueTrackerData])

// console.log("timer>>>..",timer)
  const [showQueue, setShowQueue] = useState<{ [key: string]: boolean }>({});
  const showdata = (quId: any) => {
    setShowQueue(prevState => ({
      ...prevState,
      [quId]: !prevState[quId]
    }));
  };



  const formatTimechat = (queuedTime: any) => {
    if (!isNaN(queuedTime)) {
      const timestamp = parseInt(queuedTime);
      let differenceInSeconds = servertimer - timestamp;  
      const MAX_WAIT_SECONDS = 24 * 60 * 60; // 24 hours
      if (isNaN(differenceInSeconds) || differenceInSeconds < 0 || differenceInSeconds > MAX_WAIT_SECONDS) {
        differenceInSeconds = 0;
      }
      const hours = Math.floor(differenceInSeconds / 3600);
      const difference = differenceInSeconds - hours * 3600;
      const minutes = Math.floor(difference / 60);
      const seconds = difference - minutes * 60;
      return `${hours > 0 ? hours.toString().padStart(2, "0") + "h" : ""}${minutes > 0 ? minutes.toString().padStart(2, "0") + "m" : ""}${seconds > 0 ? seconds.toString().padStart(2, "0") + "s" : "0s"}`;

    } else {
      return "-";
    }
  };
  const formatTime = (queuedTime: any) => {
    if (!isNaN(queuedTime)) {
      const timestamp = parseInt(queuedTime);
      // const currentTime = Math.floor(Date.now() / 1000); 
      // let currentTime:any = moment.tz('Europe/London').format('x')
      // const differenceInSeconds = Math.floor(currentTime / 1000) - (timestamp ); 
      // if (servertimer > timestamp) {
        const differenceInSeconds = servertimer - (timestamp);
        const hours = Math.floor(differenceInSeconds / 3600);
        const difference = differenceInSeconds - hours * 3600;
        const minutes = Math.floor(difference / 60);
        const seconds = difference - minutes * 60;

        return `${hours > 0 ? hours.toString().padStart(2, "0") + "h" : ""}${minutes > 0 ? minutes.toString().padStart(2, "0") + "m" : ""}${seconds > 0 ? seconds.toString().padStart(2, "0") + "s" : "0s"}`;
      // } else {
      //   const differenceInSeconds = timestamp - (servertimer);
      //   const hours = Math.floor(differenceInSeconds / 3600);
      //   const difference = differenceInSeconds - hours * 3600;
      //   const minutes = Math.floor(difference / 60);
      //   const seconds = difference - minutes * 60;

      //   return `${hours > 0 ? hours.toString().padStart(2, "0") + "h" : ""}${minutes > 0 ? minutes.toString().padStart(2, "0") + "m" : ""}${seconds > 0 ? seconds.toString().padStart(2, "0") + "s" : "0s"}`;
      // }

    } else {
      return "-";
    }
  };
  const currentUserExtension = loginUserCcaasDetail?.ext;
  const currentUserAgent = agentList.find(
    (agent: { ext: any; }) => agent.ext === currentUserExtension
  );
  const currentUserQuIds = currentUserAgent?.quId?.split(',') || [];
  return (
    <>
      {commonReducer?.queueTrackerData.length > 0 ? (
        commonReducer?.queueTrackerData.map((data: any, idx: any) => {
          const queueLength = isJSON(data?.queueList) ? JSON.parse(data?.queueList) : data?.queueList;
          const isQueueMapped = currentUserQuIds.includes(data?.qid?.toString());

        //   const queueList = isJSON(data?.queueList) ? JSON.parse(data?.queueList) : data?.queueList;
        //   const queueLength = Array.isArray(queueList)
        // ? queueList.filter(item => item.queuedTime === '0s')
        // : [];
          return (
            <Fragment key={idx}>
              {/* New Code ----------- */}
              {((isQueueMapped || [3, 5].includes(loginUserCcaasDetail?.roleid)) && queueLength.length > 0) && (<>
                <div className={styles.agentTrackerList}>
                  <p className={styles.queueTrackerTitle} onClick={() => showdata(data?.qid)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none" className={`${styles.queuetracksvg} ${styles.arrowmain}`}  >
                      <path d="M0.847607 11.7852C0.655207 11.7852 0.462808 11.712 0.316408 11.5645C0.0239078 11.2715 0.0249076 10.7969 0.318408 10.504L4.18271 6.65152C4.32481 6.50992 4.40291 6.32042 4.40291 6.11932C4.40291 5.91912 4.32481 5.73062 4.18271 5.58902L0.318008 1.73552C0.025008 1.44252 0.0241079 0.967921 0.316508 0.675022C0.608508 0.381122 1.08361 0.381121 1.37751 0.673021L5.24181 4.52652C5.66761 4.95132 5.90241 5.51672 5.90291 6.11932C5.90341 6.72192 5.66851 7.28732 5.24181 7.71402L1.37711 11.5665C1.23111 11.712 1.03901 11.7852 0.847607 11.7852Z" fill="#757676" />
                    </svg>
                    {data?.queueName}
                    <span>{isJSON(data?.queueList) ? `(${JSON.parse(data?.queueList)?.length ?? 0})` : `(${data?.queueList?.length ?? 0})`}</span>
                  </p>
                  {showQueue[data?.qid] && <>
                    {queueLength?.map((item: any) => (
                      <div className={styles.listSec}>
                        <div className={styles.QueuelistSec} >
                          <div className={`${styles.incomming} ${styles.callDt}`}>
                            {item.type === 'video' ? <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="30" height="30" rx="10" fill="#E2A400" />
                              <g clip-path="url(#clip0_3940_21520)">
                                <path d="M18.1819 9.2743C17.0936 8.1878 15.5084 8.0313 14.0168 7.9944C13.332 7.976 12.7478 7.9668 12.1635 7.9668C11.5792 7.9668 10.995 7.976 10.3102 7.9944C8.82803 8.0313 7.23333 8.1878 6.14523 9.2743C5.01953 10.4071 5.02893 12.2488 5.00073 13.7039V17.3046C5.02893 18.7597 5.01953 20.6014 6.14523 21.7249C7.23333 22.8114 8.81873 22.9681 10.3102 23.0048C10.995 23.0232 11.5792 23.0325 12.1635 23.0325C12.7478 23.0325 13.332 23.0232 14.0168 23.0048C15.4989 22.9681 17.0936 22.8114 18.1819 21.7249C19.3074 20.6014 19.2982 18.7597 19.3262 17.3046C19.3357 16.706 19.345 16.0982 19.3357 15.4997C19.3357 14.9012 19.3357 14.3026 19.3262 13.6948C19.2981 12.2397 19.3074 10.3979 18.1819 9.2743Z" fill="white" />
                                <path d="M23.8409 10.64C23.6483 10.64 23.4508 10.6944 23.2644 10.8138L19.8827 12.9803V18.019L23.2644 20.1853C23.4508 20.3047 23.6485 20.3593 23.8411 20.3593C24.4452 20.3593 24.9994 19.8232 24.9994 19.0739V11.9255C24.9994 11.1764 24.445 10.64 23.8409 10.64Z" fill="white" />
                              </g>
                              <defs>
                                <clipPath id="clip0_3940_21520">
                                  <rect width="24" height="24" fill="white" transform="translate(3 3.5)" />
                                </clipPath>
                              </defs>
                            </svg> : item.type === 'Chat' ?
                              <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect y="0.875" width="36" height="36" rx="12" fill="#3A3FE0" />
                                <g clip-path="url(#clip0_2137_68798)">
                                  <path d="M27.1768 15.9233V15.8833C27.1572 15.231 27.1475 14.4175 27.0114 13.6245C26.8754 12.8218 26.5837 11.9585 25.9419 11.2856C24.7559 10.0312 23.0642 9.90076 21.7613 9.87056C21.1488 9.85546 19.5714 9.84766 17.994 9.84766C16.4166 9.84766 14.8391 9.85546 14.2266 9.87056C12.914 9.90086 11.2223 10.0312 10.0263 11.2856C9.39429 11.9585 9.11249 12.8217 8.96649 13.6245C8.83059 14.4175 8.83059 15.251 8.81099 15.9131C8.80129 16.937 8.80129 17.9712 8.81099 18.9946C8.82079 19.6474 8.83059 20.4902 8.96649 21.2832C9.10269 22.0864 9.39429 22.9497 10.0361 23.6221C11.2223 24.877 12.9139 25.0074 14.2167 25.0371C15.0237 25.0576 17.4447 25.0674 19.3793 25.0674L22.9669 27.7573C23.0956 27.854 23.249 27.9033 23.4037 27.9033C23.5061 27.9033 23.609 27.8818 23.7058 27.8379C23.9488 27.7275 24.1142 27.4868 24.1432 27.2158L24.3864 24.6357C24.6877 24.5253 24.9794 24.3852 25.2516 24.2041C25.4948 24.0435 25.728 23.8628 25.9418 23.6323C26.5836 22.9599 26.8753 22.0967 27.0113 21.2934C27.1474 20.4902 27.1571 19.6572 27.1669 19.0048C27.1669 18.5331 27.1864 18.1117 27.1961 17.6298C27.1961 17.0575 27.1768 16.4955 27.1768 15.9233ZM14.2566 18.4863C13.6365 18.4863 13.134 17.978 13.134 17.352C13.134 16.725 13.6366 16.2172 14.2566 16.2172C14.8766 16.2172 15.3793 16.725 15.3793 17.352C15.3793 17.978 14.8766 18.4863 14.2566 18.4863ZM17.9999 18.4863C17.3798 18.4863 16.8773 17.978 16.8773 17.352C16.8773 16.725 17.3799 16.2172 17.9999 16.2172C18.6199 16.2172 19.1226 16.725 19.1226 17.352C19.1226 17.978 18.62 18.4863 17.9999 18.4863ZM21.7432 18.4863C21.1231 18.4863 20.6205 17.978 20.6205 17.352C20.6205 16.725 21.1231 16.2172 21.7432 16.2172C22.3633 16.2172 22.8658 16.725 22.8658 17.352C22.8658 17.978 22.3632 18.4863 21.7432 18.4863Z" fill="white" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2137_68798">
                                    <rect width="24" height="24" fill="white" transform="translate(6 6.875)" />
                                  </clipPath>
                                </defs>
                              </svg>
                              : item.type === "Whatsapp" ? <span className="icon__Whatsapp36" />
                                : item.type === "Facebook" ? <span className="icon__Fb36" />
                                  : item.type === "Instagram" ? <span className="icon__Insta36" />
                                    : <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect y="0.423096" width="36" height="36" rx="12" fill="#00b885" />
                                      <g clip-path="url(#clip0_1168_29246)">
                                        <path d="M10.7771 10.0031L10.9863 9.86154C12.1538 9.11254 13.6991 9.37574 14.5965 10.4758L15.8248 11.9873C16.5873 12.9253 16.6952 14.248 16.0811 15.2805L15.0756 16.9878C14.9137 17.2576 15.3927 18.1148 16.5872 19.3225C17.7951 20.5171 18.6523 20.9961 18.9289 20.8411L20.6295 19.8286C21.6687 19.2214 22.9846 19.3225 23.9293 20.0918L25.4409 21.3201C26.5409 22.2176 26.8041 23.763 26.0483 24.9236L25.9133 25.1397C24.8877 26.7322 22.9779 27.6836 21.0547 27.3397C18.5645 26.8873 15.9867 25.3085 13.2875 22.6227C10.6084 19.9301 9.02264 17.3456 8.57724 14.8622C8.23314 12.9389 9.18454 11.029 10.7771 10.0031Z" fill="white" />
                                        <path d="M23.02 9.44464C22.7481 9.39544 22.4881 9.57624 22.4392 9.84814C22.3901 10.1197 22.5708 10.3797 22.8427 10.4289C24.7666 10.765 26.3477 12.5838 26.4818 14.5397C26.4927 14.6912 26.4956 14.843 26.4897 14.9947C26.4786 15.2707 26.6935 15.5032 26.9696 15.5141C27.2455 15.525 27.4781 15.3103 27.4891 15.0343C27.4965 14.8438 27.4928 14.6541 27.479 14.4669C27.2931 12.0426 25.4348 9.89094 23.02 9.44464Z" fill="white" />
                                        <path d="M22.313 11.6244C22.0411 11.5755 21.7811 11.756 21.7323 12.0279C21.6834 12.2998 21.864 12.5598 22.1359 12.6087C23.2252 12.7938 24.1451 13.8492 24.2176 14.9628L24.2221 15.222C24.2114 15.4979 24.4264 15.7302 24.7025 15.7409C24.9784 15.7516 25.2108 15.5366 25.2215 15.2607C25.2261 15.1365 25.2238 15.0126 25.2149 14.8901C25.0905 13.308 23.8934 11.9197 22.313 11.6244Z" fill="white" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1168_29246">
                                          <rect width="24" height="24" fill="white" transform="translate(6 6.4231)" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                            }

                          </div>
                          <div className={styles.middle}>
                            <div className={styles.details}>

                              <h4>{item?.firstName || "New customer"} {item?.lastName || ""} </h4>
                              <h4>{item?.from === "" ? item.callbackDid : item?.from}</h4>
                              <p>{item?.ddi === "" ? item?.callType : ""}</p>
                            </div>
                            <div>
                              <div className={styles.timerbg}>
                                <span className={styles.timer}>
                                  {/* <span className="icon__Timer16" /> */}
                                </span>
                                {/* <span className={`${styles.timer}`}>{formatTime(Number(item?.queuedTime.split(" ")[0]) + counter)}</span>
                           */}
                                <span className={`${styles.timer}`}>{item.type === 'Chat'  ? formatTimechat(item?.queuedTime): formatTime(item?.queuedTime)}</span>
                              </div>
                              <span className={styles.time}>{"Waiting Time"}</span>
                            </div>
                            {/* <div className={styles.queuebtn}>
                          <button>Answer</button>
                        </div> */}
                          </div>
                          {/* <div className={styles.rights}>
                        <div className={styles.timerbg}> */}
                          {/* <span className={styles.timer}>
                            <span className="icon__Timer16" />
                          </span> */}
                          {/* <span className={`${styles.timer}`}>{formatTime(Number(item?.duration.split(" ")[0]) + counter)}</span>
                        </div>  */}
                          {/* <div className={styles.timerbtn}>
                          <Button className={`buttonGreenBdr hmd`} onClick={() => answerCall}>
                            Answer
                          </Button>
                        </div> */}
                          {/* </div> */}
                        </div>
                      </div>
                    ))}</>}
                </div>
                {/* <div className={styles.agentTrackerList}>
                    <p className={styles.queueTrackerTitle}>Basic Queue <span>(3)</span></p>
                    <div className={styles.QueuelistSec}>
                      <div className={`${styles.incomming} ${styles.callDt}`}>
                          <span className="icon__InteractionMessage24"></span>
                      </div>
                      <div className={styles.middle}>
                        <div className={styles.details}>
                          <h4>Christoper</h4>
                          <p>+442365324321</p>
                        </div>
                        </div>
                        <div className={styles.rights}>
                          <div className={styles.timerbg}>
                            <span className={styles.timer}>
                              <span className="icon__Timer16" />
                            </span>
                            <span className={`${styles.timer} ${styles.green}`}>00m55s</span>
                          </div>
                          <div className={styles.timerbtn}>
                            <Button className={`buttonGreenCreate lightGreenbgcolor lightGreenbgcolorsmall`}>Accept</Button>
                          </div>
                        </div>
                    </div>
                    </div> */}

                {/* Previous Code ----------- */}
                {/* <div className={styles.agentTrackerList}>
                        <p className={styles.queueTrackerTitle}>
                          {data?.queueName} <span>{`(${JSON.parse(data?.queueList).length})`}</span>
                        </p>
                        {queueLength.length > 0 &&
                          queueLength?.map((item: any) => {
                            return (
                              <>
                                <div className={styles.listSec}>
                                  <div className={styles.middle}>
                                    <div className={styles.callDt}>
                                      <h4>{item?.customerName}</h4>
                                      <p>
                                        <span className={styles.timer}>{item?.from}</span>
                                      </p>
                                    </div>
                                    <div className={styles.callAction} onClick={() => answerCall(data)}>
                                      <span className="icon__Answer16" />
                                      Answer
                                    </div>
                                  </div>
                                  <div className={styles.rights}>
                                    <span className={styles?.callNumber}> {item?.ddi}</span>
                                    <span className={styles.timer}>
                                      <span className="icon__Timer16" /> &nbsp; {formatTime(Number(item?.duration.split(" ")[0]) + counter)}
                                    </span>
                                  </div>
                                </div>
                              </>
                            );
                          })}
                      </div> */}
              </>)}
            </Fragment>
          );
        })
      ) : (
        <div className="nodatafoundfrque">
          <NoDataFound />
        </div>
      )}
    </>
  );
}

export default AgentQueueTracker;
